











































































import {
  Permission,
} from '@/models';
import {
  OpportunityMembershipStatus,
  OpportunityItemStatus,
  OpportunityItemOtherStatus,
  OpportunityActions,
  Opportunity,
  OpportunityDraft,
} from '@/models/opportunities';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'FooterActionDispatcher',
  props: {
    opportunity: Object as () => Opportunity,
    opportunityDraft: Object as () => OpportunityDraft,
  },
  computed: {
    isAskMoreActionVisible(): boolean {
      return this.opportunity.status === OpportunityItemStatus.Recruiting
        && this.opportunity.issuer.id !== this.$store.state.geek.current.id;
    },
    isAddNoteActionVisible(): boolean {
      return [OpportunityItemStatus.Recruiting, OpportunityItemStatus.Ongoing].includes(this.opportunity.status)
        && this.opportunity.issuer.id === this.$store.state.geek.current.id;
    },
    isGiveFeedbackActionVisible(): boolean {
      return [OpportunityItemStatus.Finalized, OpportunityItemStatus.Canceled].includes(this.opportunity.status)
        && this.opportunity.members.some(m => m.geek.id === this.$store.state.geek.current.id);
    },
    isApplyActionVisible(): boolean {
      return this.opportunity.status === OpportunityItemStatus.Recruiting
        && this.opportunity.selfMembershipStatus === OpportunityMembershipStatus.None
        && this.opportunity.issuer.id !== this.$store.state.geek.current.id;
    },
    isLeaveActionVisible(): boolean {
      return this.opportunity.selfMembershipStatus === OpportunityMembershipStatus.Waiting;
    },
    isApproveActionVisible(): boolean {
      return ((this.$store.state.geek.current.permissions.includes(Permission.OpportunityApproveReject)
        && this.opportunity.issuer.id !== this.$store.state.geek.current.id)
        || this.$store.state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Pending;
    },
    isLaunchActionVisible(): boolean {
      return (this.opportunity.issuer.id === this.$store.state.geek.current.id
        || this.$store.state.geek.current.permissions.includes(Permission.OpportunityManage))
        && this.opportunity.status === OpportunityItemStatus.Recruiting;
    },
    isLaunchActionDisabled(): boolean {
      const evaluation = this.opportunity.members.some(
        m => m.membershipStatus === OpportunityMembershipStatus.Waiting,
      ) || !this.opportunity.members.some(
        m => m.membershipStatus === OpportunityMembershipStatus.Accepted,
      );
      requestAnimationFrame(() => {
        if (evaluation) {
          this.$root.$emit('bv::enable::tooltip', 'launch-button');
        } else {
          this.$root.$emit('bv::disable::tooltip', 'launch-button');
        }
      });

      return evaluation;
    },
    isShareDraftActionVisible(): boolean {
      return ( OpportunityItemOtherStatus.Draft === this.opportunityDraft.status );
    },
    isEditDraftActionVisible(): boolean {
      return (OpportunityItemOtherStatus.Draft === this.opportunityDraft.status)
        && (this.$store.state.geek.current.id === this.opportunityDraft.issuer.id);
    },
  },
  methods: {
    apply(): void {
      this.$emit(OpportunityActions.Apply);
    },
    leave(): void {
      this.$emit(OpportunityActions.Leave);
    },
    approve(): void {
      this.$emit(OpportunityActions.Approve);
    },
    launch(): void {
      this.$emit(OpportunityActions.Launch);
    },
    sendMessage(): void {
      this.$emit(OpportunityActions.SendMessage);
    },
    giveFeedback(): void {
      this.$emit(OpportunityActions.GiveFeedback);
    },
    draftLink(): string {
      return window.location.origin + this.$route.fullPath;
    },
    showSuccessToastDraftLinkCopied(): void {
      ToastsService.success(this.$t('opportunities.details.notifications.copy-draft-link') as string);
    },
    editDraft(): void {
      this.$router.push({
        name: 'opportunity-draft-edit',
        params: {
          id: this.opportunityDraft.id,
        },
      });
    },
  },
});
